export const CINTURONES = "Cinturones";
export const NIVELES = "Paso Niveles";
export const PLANETAS = "Planetas";
export const HISTORIAS = "Historias";
export const MINIJUEGOS = "Mini juegos";



// WEBPACK FOOTER //
// src/Pages/Demografico/ubicacion/Localidad/component/consts_act.js